import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ConfirmProvider } from "./context/ConfirmContext";
import { Toaster } from "sonner";

import Landing from "./pages/Landing";
import ScanPage from "./pages/ScanPage";
import BusinessAffiliate from "./pages/BusinessAffiliate";
import Directory from "./pages/Directory";
import Directories from "./pages/Directories";
import Login from "./pages/Login";
import Register from "./pages/Register";
import CustomerRegister from "./pages/CustomerRegister";
import CustomerLogin from "./pages/CustomerLogin";
import CustomerDashboard from "./pages/CustomerDashboard";
import BusinessDashboard from "./pages/BusinessDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import PromoterLogin from "./pages/PromoterLogin";
import PromoterRegister from "./pages/PromoterRegister";
import PromoterDashboard from "./pages/PromoterDashboard";
import Winners from "./pages/Winners";
import MenuPage from "./pages/MenuPage";
import ForgotPassword from "./pages/ForgotPassword";
import About from "./pages/About";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import SoftBack from "./components/SoftBack";
import PWAInstallBanner from "./components/PWAInstallBanner";
import ImpersonationBanner from "./components/ImpersonationBanner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ConfirmProvider>
        <BrowserRouter>
          <ScrollToTop />
          <SoftBack />
          <ImpersonationBanner />
          <PWAInstallBanner />
          <Toaster richColors position="top-right" />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/escanear/:businessId" element={<ScanPage />} />
            <Route path="/afilia-tu-negocio" element={<BusinessAffiliate />} />
            <Route path="/directorios" element={<Directories />} />
            <Route path="/directorio/:cp" element={<Directory />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin-login" element={<Navigate to="/login?admin=1" replace />} />
            <Route path="/registro" element={<Register />} />
            <Route path="/registro-cliente" element={<CustomerRegister />} />
            <Route path="/login-cliente" element={<CustomerLogin />} />
            <Route path="/login-promotor" element={<PromoterLogin />} />
            <Route path="/registro-promotor" element={<PromoterRegister />} />
            <Route path="/recuperar-contrasena" element={<ForgotPassword />} />
            <Route path="/ganadores" element={<Winners />} />
            <Route path="/menu/:identifier" element={<MenuPage />} />
            <Route path="/quienes-somos" element={<About />} />
            <Route path="/terminos" element={<Terms />} />
            <Route path="/privacidad" element={<Privacy />} />
            <Route
              path="/promotor"
              element={<ProtectedRoute role="promoter"><PromoterDashboard /></ProtectedRoute>}
            />
            <Route
              path="/mi-cuenta"
              element={<ProtectedRoute role="customer"><CustomerDashboard /></ProtectedRoute>}
            />
            <Route
              path="/dashboard"
              element={<ProtectedRoute role="business"><BusinessDashboard /></ProtectedRoute>}
            />
            <Route
              path="/admin"
              element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>}
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </ConfirmProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
